import { EEirSalesSimType } from "@mappers/getCartMapper";
import { EAppointmentSlot, EAppointmentType, EServiceGroup, EServiceTechnology } from "@constants";
import { IAddress } from "@interface/customerDetails/IAddress";

export interface ICart {
    nbrAdditionalAllowedMobileSubscriptions: number;
    nbrAdditionalAllowedBroadbandSubscriptions: number;
    offers: ICartOffer[];
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
}

export interface IPrequal {
    prequalId: string;
    addressResponse: IAddress;
    onlinePrequalId: string;
    isPreOrder: boolean;
    services: IService[];
    serviceDate?: Date;
}

export interface IService {
    broadbandTechnology: EServiceTechnology;
    slotAvailable: boolean;
}

export interface IAppointment {
    type?: EAppointmentType;
    at?: Date;
    time?: EAppointmentSlot;
}

export interface IRecurringAmount {
    amount: number;
    discountFrequency?: string;
    discountOccurrence?: number;
    discountedAmount?: number;
}

export interface ICartAmountVatIncluded {
    recurringAmount: IRecurringAmount;
}

export interface ICartAddon {
    id: number;
    catalogCode: string;
    description: string;
    amountVatIncluded: ICartAmountVatIncluded;
}

export interface ICartOffer {
    baseOffer: IOffer;
    offerId: number;
    port?: ICartPortin;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
    simType: EEirSalesSimType;
    prequal?: IPrequal;
    appointment?: IAppointment;
    activationAt?: Date;
    addOns: ICartAddon[];
}

export enum EBroadbandTechnology {
    FTTH = "FTTH",
}

export interface ICatalogOffer {
    catalogOfferCode: string;
    description: string;
    comment: string;
    displayOrder: number;
    recurringChargeAmount: number;
    discountedRecurringChargeAmount?: number;
    activationFee?: number;
    usages: IUsage[];
    broadbandTechnology: EBroadbandTechnology | undefined;
    serviceGroup: EServiceGroup;
}

export interface IOffer extends ICatalogOffer {
    upFrontChargeAmount: number;
}

interface IUsage {
    description: string;
    displayOrder: number;
}

export interface ICartPortin {
    phoneNumber: string;
    portStartDateTime: string;
}

export interface IPortin {
    otherNetworkAccountNumber: string | undefined;
    otherNetworkId: number | undefined;
    otherNetworkName: string;
    phoneNumber: string;
    portStartDateTime: string;
    type: string;
}
